import { FrameProviderFramerV2 } from "./utils/framer_v2/frameprovider";
import { RoutesProvider } from "./utils/framer_v2/routesprovider";
import { GeohashGeometryProvider } from "./GeohashGeometryProvider";
import { ICoreNodeWrapperBase, IFillNodeWrapperBase, IFullNodeWrapperBase, Infra3DDataProviderBase, UtilsBase, } from "./Infra3DDataProviderBase";
// TODO: Sort and structure all import of mapillary code.
// TODO: Option guards.
// TODO: Once in infra3dsdk, really think about frame props, capturesystem and framedatameta.
// Geoframe vs MeasureInfo.
// TODO: Remove more that is not needed.
// TODO: Typesafer IO
// TODO: Options of viewer need to be asserted at one place.
class Utils extends UtilsBase {
    static coreImages(frames) {
        const res = {};
        for (const frame of frames) {
            res[frame.key] = new ICoreNodeWrapperV2(frame);
        }
        return res;
    }
    static fillImages(frames) {
        const res = {};
        for (const frame of frames) {
            res[frame.key] = new IFillNodeWrapperV2(frame);
        }
        return res;
    }
    static fullImages(frames) {
        const res = {};
        for (const frame of frames) {
            res[frame.key] = new IFullNodeWrapperV2(frame);
        }
        return res;
    }
}
export class ICoreNodeWrapperV2 extends ICoreNodeWrapperBase {
    constructor(frame) {
        super(frame);
        this.frame = frame;
    }
    get sequence_key() {
        return String(`${this.frame.collection}/${this.frame.stream}`);
    }
}
export class IFillNodeWrapperV2 extends IFillNodeWrapperBase {
    constructor(frame) {
        super(frame);
        this.frame = frame;
    }
    get captured_with_camera_uuid() {
        return this.frame.capturesystem.name;
    }
}
export class IFullNodeWrapperV2 extends IFullNodeWrapperBase {
    constructor(frame) {
        super();
        this.iCoreNodeWrapper = new ICoreNodeWrapperV2(frame);
        this.iFillNodeWrapper = new IFillNodeWrapperV2(frame);
    }
}
export class Infra3DDataProvider extends Infra3DDataProviderBase {
    constructor(options, authObject, lidarprovideroptions, geometry) {
        super(options, authObject, undefined, lidarprovideroptions, geometry ? geometry : new GeohashGeometryProvider(options.collection));
        this.frameProvider = new FrameProviderFramerV2(options.host, authObject);
        this.routesProvider = new RoutesProvider(options.host, authObject);
        this.collection = options.collection;
        this.framer_version = "2";
    }
    getCoreImages(cellId) {
        const corners = UtilsBase.cornersProjectedTo(this._geometry.getCorners(cellId));
        return new Promise((resolve, reject) => {
            function handleSuccess(frames) {
                resolve({ [cellId]: Utils.coreImages(frames) });
            }
            function handleError(error) {
                reject(error);
            }
            this.frameProvider.allWithin(this.collection, corners.sw.lon, corners.se.lon, corners.se.lat, corners.ne.lat, 4326, handleSuccess, handleError);
        });
    }
    getFillImages(imageKeys) {
        return new Promise((resolve, reject) => {
            let count = imageKeys.length;
            const res = [];
            function handleSuccess(frame) {
                count = count - 1;
                res.push(frame);
                if (count === 0) {
                    resolve(Utils.fillImages(res));
                }
            }
            function handleError(error) {
                reject(error);
            }
            for (const imageKey of imageKeys) {
                this.frameProvider.get(this.collection, imageKey, handleSuccess, handleError);
            }
        });
    }
    getFullImages(imageKeys) {
        return new Promise((resolve, reject) => {
            let count = imageKeys.length;
            const res = [];
            function handleSuccess(frame) {
                count = count - 1;
                res.push(frame);
                if (count === 0) {
                    resolve(Utils.fullImages(res));
                }
            }
            function handleError(error) {
                reject(error);
            }
            for (const imageKey of imageKeys) {
                this.frameProvider.get(this.collection, imageKey, handleSuccess, handleError);
            }
        });
    }
    getRoutes(options) {
        if (options === undefined)
            options = {};
        options.simplify = options.simplify || 1;
        options.segmentedonly = options.segmentedonly || false;
        return new Promise((resolve, reject) => {
            this.routesProvider.allRoutes(this.collection, options.simplify, options.segmentedonly, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    findNearest(easting, northing, epsg) {
        return new Promise((resolve, reject) => {
            function handleError(error) {
                reject(error);
            }
            this.frameProvider.findNearest(this.collection, easting, northing, epsg, (frames) => {
                resolve(Utils.fullImages(frames)[frames[0].key]);
            }, handleError);
        });
    }
    set authObject(authObject) {
        this.frameProvider.authObject = authObject;
        this.routesProvider.authObject = authObject;
    }
}
//# sourceMappingURL=Infra3DDataProvider_v2.js.map